var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M57.66 23.828a1 1 0 1 1-2 0 1 1 0 0 1 2 0M60.104 22.828a1 1 0 1 0 0 2h4.848a1 1 0 1 0 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 20.802a2 2 0 0 1 2-2h56a2 2 0 0 1 2 2v38.396a2 2 0 0 1-2 2H50.422l-.07.002h-4.247a1 1 0 0 1-.017-2v-.002H68V28.946H12v30.252h22.441v.01a1 1 0 0 1 0 1.985v.005h-.053l-.07.002H30.06l-.06-.002H12a2 2 0 0 1-2-2zm2 6.144h56v-6.144H12z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.558 34.057a1 1 0 0 1 1.414 0l6.364 6.364a1 1 0 1 1-1.414 1.414l-4.657-4.657v26.586a1 1 0 1 1-2 0V37.178l-4.657 4.657a1 1 0 0 1-1.414-1.414z"
  })));
};
export default SvgPublish;